// src/api/options.ts
import request from '@/utils/request';

export interface CarSetDto {
  id: number
  productType: string
  brand: string
  type: string
  cc: string
  microloantype: string
}

export const optionsApi = {
  /**
   * 取得表單下拉選單、地址連動中繼資料
   */
  getMetadata() {
    return request({
      url: '/api/GetOptions/metadata',
      method: 'get'
    });
  },
  getProjects() { //取得有效專案
    return request({
      url: '/api/GetOptions/projects',
      method: 'get'
    });
  },
  getCarSets() { //取得有效車型
    return request({
      url: '/api/GetOptions/car-sets',
      method: 'get'
    });
  },
};
